export default __webpack_public_path__ + "static/media/Resume.ff794341.pdf";